export default __webpack_public_path__ + "static/media/nigeria-portharcourt-reniery.7f4aa6e0.png";